import React, { useEffect, useState } from "react";

import EditButtonConfig from "../../../../../components/EditComponents/EditButtonConfig";
import { getDefaultConfig } from "../../../../../utils/Config/getDefaultConfig";
import MaterialIcon from "../../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../../utils/objectIdUtils";

const EditActions = ({ id, actions, setActions, device, tableId, tableType = "statemachine", elements }) => {
  const [actionList, setActionList] = useState(null);
  const initialCustom = { show: false, id: "" };
  const [selectedCustomColumnElement, setSelectedCustomColumnElement] = useState(initialCustom);

  const closeCustomColumn = () => {
    setSelectedCustomColumnElement(initialCustom);
  };

  const changeCustomElement = (obj, index) => {
    const newObj = {
      id: obj.id,
      type: obj.type,
      show: true,
      index: index,
      device: device,
      config: obj,
      elements: elements,
      sm_id: true
    };
    setSelectedCustomColumnElement(newObj);
  };

  const deleteColumnElement = (id) => {
    let copyActions = JSON.parse(JSON.stringify(actionList));
    const newArray = copyActions.filter((ele) => ele.id !== id);
    copyActions = newArray;
    setActions(copyActions);
    setActionList(copyActions);
    if (id === selectedCustomColumnElement.id) closeCustomColumn();
  };

  const addElementToCustom = (type) => {
    const copyActions = [...actionList];
    let obj = {};

    if (type === "button") {
      obj = getDefaultConfig("button");
    }
    if (type === "dropdown") {
      obj = getDefaultConfig("dropdown");
    }
    obj.id = generateObjectId();
    const newObj = {
      id: obj.id,
      type: obj.type,
      show: true,
      index: copyActions.length,
      device: device,
      config: obj,
      elements: elements,
      sm_id: true
    };
    copyActions.push({ ...obj });

    setActions(copyActions);
    setActionList(copyActions);
    setSelectedCustomColumnElement(newObj);
  };

  const handleSaveColumnConfig = (where, config) => {
    const copyActions = JSON.parse(JSON.stringify(actionList));
    copyActions[selectedCustomColumnElement.index] = config;
    setActionList(copyActions);
    setActions(copyActions);
    // setSelectedCustomColumnElement({ show: false, id: "" });
  };

  useEffect(() => {
    setActionList(actions);
    closeCustomColumn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!actionList) return;
  return (
    <div className="edit_recordView_action">
      <div className="select_button_outer">
        <div className="select_button_label">
          <p>Add Button</p>
        </div>
        <div className="select_button_container">
          <div className="select_button" onClick={() => addElementToCustom("button")}>
            <p>Button</p>
          </div>
          <div className="select_button" onClick={() => addElementToCustom("dropdown")}>
            <p>Drop down</p>
            <MaterialIcon name="expand_more" />
          </div>
        </div>
      </div>
      <div className="button_selected_form">
        <div className="button_inside_selected">
          {actionList.map((element, index) => (
            <div
              key={`${element.id}-${index}`}
              className={`button_column_list ${element.id === selectedCustomColumnElement.id ? "selected" : ""}`}
            >
              <span key={element.id} onClick={() => changeCustomElement(element, index)}>
                {element.name}
              </span>
              <div className="icons">
                <MaterialIcon name="edit" className="edit_icon" onClick={() => changeCustomElement(element, index)} />
                <MaterialIcon name="delete" className="delete_icon" onClick={() => deleteColumnElement(element.id)} />
              </div>
            </div>
          ))}
        </div>
        <hr className="button_selected_break_line" />
        <div
          className="edit_recordsview_right_panel edit_right_panel_ActionInside pl_0"
          style={{ maxWidth: "55%", minWidth: "55%" }}
        >
          {selectedCustomColumnElement.show && (
            <EditButtonConfig
              editElementRightsidebar={selectedCustomColumnElement}
              onSave={(config) => handleSaveColumnConfig("action", config)}
              places="records_view_header"
              smId={tableId}
              device={device}
              type={tableType}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditActions;
